<div *ngIf="validApiKey; else invalidKey">
  <div class="ui-g">
    <div class="ui-g-3 tabs" [class.selected]="tabShown == 1" (click)="goToTab(1)">Quote</div>
    <div
      class="ui-g-3 tabs"
      [class.selected]="tabShown == 2"
      (click)="tabShown == 1 && this.showPrice ? handleEnterDetails() : goToTab(2)"
    >
      Contact
    </div>
    <div class="ui-g-3 tabs" [class.selected]="tabShown == 3" (click)="goToTab(3)">Billing</div>
    <div class="ui-g-3 tabs" [class.selected]="tabShown == 4" (click)="goToTab(4)">Payment</div>
  </div>
  <div class="body">
    <ng-template [ngTemplateOutlet]="tab1" *ngIf="tabShown == 1"></ng-template>
    <ng-template [ngTemplateOutlet]="tab2" *ngIf="tabShown == 2"></ng-template>
    <ng-template [ngTemplateOutlet]="tab3" *ngIf="tabShown == 3"></ng-template>
    <ng-template [ngTemplateOutlet]="tab4" *ngIf="tabShown == 4"></ng-template>
  </div>

  <!--
  <div class="big-button" style="display: inline-block; margin-right: 10px" (click)="populateQuote()">
    Populate Quote
  </div>
  <div class="big-button" style="display: inline-block" (click)="populateIntent()">
    Populate Intent
  </div>

  <div class="mt-3" style="font-size: 12px; line-height: 14px">
  <pre>
  {{ quote | json }}
  </pre>
  </div>
  -->
</div>
<ng-template #invalidKey>
  <div style="display: flex; align-items: center; justify-content: center; height: 100vh">
    <div>
      <div>Booking Tool not available.</div>
      <div>Contact your Administrator</div>
    </div>
  </div>
</ng-template>

<ng-template #tab1>
  <div *ngIf="isLoading" class="loading-notice">
    <span>
      <i class="fa fa-spin fa-2x fa-spinner"></i>
    </span>
  </div>
  <ng-container *ngIf="!isLoading">
    <div class="ui-g quote-request-wrapper" [class.expand]="showAddress">
      <div class="ui-g-12 ui-lg-6">
        <div style="position: relative">
          <span class="ui-float-label">
            <input
              pInputText
              id="vrm"
              class="b2c-input uppercase"
              [(ngModel)]="vrm"
              (blur)="vrmLookup()"
            />
            <label for="vrm">Vehicle Registration</label>
          </span>

          <span class="input-error" *ngIf="invalidVRM"
            >We are unable to find a vehicle with that registration</span
          >

          <span class="input-error" *ngIf="kerbWeightDialogCancelled">
            Vehicle cleared due to missing kerb weight entry. Please try again.
          </span>

          <div style="position: absolute; top: 10px; right: 10px" *ngIf="!invalidVRM">
            <div class="make-model">{{ quote?.quoteVehicle?.make }}</div>
            <div class="make-model">{{ quote?.quoteVehicle?.model }}</div>
          </div>
        </div>
      </div>
      <div class="ui-g-12 ui-md-6 ui-lg-3">
        <div
          (click)="setTaskType(TaskType.UncoveredTransportedMovement)"
          class="big-button text-left selection-button"
          [class.selected]="quote?.taskTypeId == TaskType.UncoveredTransportedMovement"
        >
          <table>
            <tr>
              <td class="check-cell">
                <input
                  type="radio"
                  class="deliver-choice"
                  [checked]="quote?.taskTypeId == TaskType.UncoveredTransportedMovement"
                />
              </td>
              <td><i class="fa fa-truck fa-12x"></i> &nbsp; Transported</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ui-g-12 ui-md-6 ui-lg-3">
        <div
          (click)="setTaskType(TaskType.DrivenPlated)"
          class="big-button selection-button text-left"
          [class.selected]="quote?.taskTypeId == TaskType.DrivenPlated"
        >
          <table>
            <tr>
              <td class="check-cell">
                <input
                  type="radio"
                  class="deliver-choice"
                  [checked]="quote?.taskTypeId == TaskType.DrivenPlated"
                />
              </td>
              <td>
                <i class="fa fa-car fa-12x"></i>
                &nbsp; Driven
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <form *ngIf="step1" [formGroup]="step1" class="ui-g">
      <div class="ui-g-6 ui-sm-12">
        <div class="mb-3">
          <div style="position: relative">
            <div>
              <span class="ui-float-label">
                <input
                  pInputText
                  class="b2c-input"
                  formControlName="pickupPostcode"
                  id="pickupPostcode"
                />
                <label for="pickupPostcode">Collection Postcode</label>
              </span>
            </div>

            <span
              class="input-error"
              *ngIf="
                step1?.controls?.pickupPostcode.invalid && step1?.controls?.pickupPostcode.touched
              "
              >A valid postcode is required</span
            >
            <div class="change-address-button" (click)="searchPostcodeAddress(true)">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>
        <p-dropdown
          class="b2c-input"
          [options]="pickupAddresses"
          [ngModel]="selectedPickupAddress"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="onSelectedAddressChange($event, true)"
          optionLabel="address"
          placeholder="Select Address..."
          *ngIf="selectingPickupAddress"
        ></p-dropdown>
        <span class="input-error" *ngIf="noMatchedPickupAddress">
          No matching address found, please manually select an address.
        </span>
        <div style="position: relative" *ngIf="!selectingPickupAddress && pickupAddress">
          <div>
            <span class="ui-float-label">
              <input
                pInputText
                class="b2c-input"
                disabled="true"
                [(ngModel)]="pickupAddress"
                [ngModelOptions]="{ standalone: true }"
              />
              <label for="pickupPostcode">Collection Address</label>
            </span>
          </div>

          <div class="change-address-button" (click)="selectingPickupAddress = true">
            <i class="fa fa-pencil"></i>
          </div>
        </div>
      </div>
      <div class="ui-g-6 ui-sm-12">
        <div class="mb-3">
          <div style="position: relative">
            <div>
              <span class="ui-float-label">
                <input
                  pInputText
                  formControlName="dropoffPostcode"
                  class="b2c-input"
                  id="dropoffPostcode"
                />
                <label for="dropoffPostcode">Delivery Postcode</label>
              </span>
            </div>
            <span
              class="input-error"
              *ngIf="
                step1?.controls?.dropoffPostcode.invalid && step1?.controls?.dropoffPostcode.touched
              "
              >A valid postcode is required</span
            >
            <div class="change-address-button" (click)="searchPostcodeAddress(false)">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>
        <div>
          <p-dropdown
            class="b2c-input"
            [options]="dropoffAddresses"
            [ngModel]="selectedDropoffAddress"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="onSelectedAddressChange($event, false)"
            optionLabel="address"
            placeholder="Select Address..."
            *ngIf="selectingDropoffAddress"
          ></p-dropdown>
          <span class="input-error" *ngIf="noMatchedDropoffAddress">
            No matching address found, please manually select address.
          </span>
          <div style="position: relative" *ngIf="!selectingDropoffAddress && dropoffAddress">
            <div>
              <span class="ui-float-label">
                <input
                  pInputText
                  class="b2c-input"
                  disabled="true"
                  [(ngModel)]="dropoffAddress"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label for="pickupPostcode">Delivery Address</label>
              </span>
            </div>

            <div class="change-address-button" (click)="selectingDropoffAddress = true">
              <i class="fa fa-pencil"></i>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="ui-g" *ngIf="canShowDateChoices && !isOffshoreQuote">
      <div class="ui-g-12 py-0">
        <div class="input-label">Deliver Within</div>
      </div>
      <div class="ui-g-12 ui-lg-4 pt-0">
        <div
          class="big-button text-left selection-button"
          style="height: 50px"
          [class.selected]="leadTime == 'urgent'"
          (click)="setLeadTime('urgent')"
        >
          <table>
            <tr>
              <td class="check-cell">
                <input type="radio" [checked]="leadTime == 'urgent'" class="deliver-choice" />
              </td>
              <td>
                <div class="text-left">
                  <span class="day-count">{{ this.quote.urgentHours / 24 }}</span>
                  <span class="working-days">working days</span>
                </div>
                <div class="bydate">By: {{ urgentEnds() | datex : 'ddd Do MMM' }}</div>
              </td>
              <td>
                <span *ngIf="fetchingQuote">
                  <i class="fa fa-spin fa-spinner"></i>
                </span>
                <span *ngIf="!fetchingQuote">
                  <span class="days-price">&pound;{{ quote.urgentPrice | number : '1.2-2' }}</span>
                  <span class="plus-vat">+VAT</span>
                  <div class="urgentmove" style="font-size: 12px; line-height: 12px">
                    Urgent Move
                  </div>
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ui-g-12 ui-lg-4 pt-0">
        <div
          class="big-button text-left selection-button"
          style="height: 50px"
          [class.selected]="leadTime == 'standard'"
          (click)="setLeadTime('standard')"
        >
          <table>
            <tr>
              <td class="check-cell">
                <input type="radio" [checked]="leadTime == 'standard'" class="deliver-choice" />
              </td>
              <td>
                <div class="text-left">
                  <span class="day-count">7</span> <span class="working-days">working days</span>
                </div>
                <div class="bydate">By: {{ standardEnds() | datex : 'ddd Do MMM' }}</div>
              </td>
              <td>
                <span *ngIf="fetchingQuote">
                  <i class="fa fa-spin fa-spinner"></i>
                </span>
                <span *ngIf="!fetchingQuote">
                  <span class="days-price"
                    >&pound;{{ quote.standardPrice | number : '1.2-2' }}</span
                  >
                  <span class="plus-vat">+VAT</span>
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ui-g-12 ui-lg-4 pt-0">
        <div
          class="big-button text-left selection-button"
          style="height: 50px"
          [class.selected]="leadTime == 'custom'"
          (click)="showSpecificDateDialog()"
        >
          <div style="">
            <table>
              <tr>
                <td class="check-cell">
                  <input
                    type="radio"
                    [checked]="leadTime == 'custom'"
                    (click)="showSpecificDateDialog()"
                    class="deliver-choice"
                  />
                </td>
                <td>
                  <div>Specific date</div>
                  <div class="bydate">
                    Collection:
                    {{ quote.pickupDateTimeEarliest | datex : 'ddd MMM DD HH:00' }}
                    -
                    {{ specificDateLatest | datex : 'HH:00' }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showPrice">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6" *ngIf="showRoute()">
          <div style="max-height: 270px">
            <map-control
              [origin]="map.pickup"
              [destination]="map.dropoff"
              [readOnly]="true"
              [customStyle]="{
                'max-height': '270px',
                width: '100%',
                height: '270px',
                'border-radius': '5px'
              }"
            ></map-control>
          </div>
        </div>

        <div class="ui-g-12 ui-md-6">
          <div class="white-box">
            <div class="ui-g">
              <div class="ui-g-6 ui-md-5" style="display: flex; align-items: center">
                <div class="pl-3 pb-3 pt-2 your-quote">
                  <b2c-price-display
                    [quote]="quote"
                    (showDiscountCodeDialog)="showDiscountCodeDialog()"
                  ></b2c-price-display>
                </div>
              </div>
              <div class="ui-g-6 ui-md-7">
                <div class="quoted-price">
                  <div class="pb-2">Price includes:</div>
                  <div class="pb-1">
                    <i class="fa fa-check green-check"></i>&nbsp;Pre-collection inspection
                  </div>
                  <div class="pb-1"><i class="fa fa-check green-check"></i>&nbsp;Fuel</div>
                  <div class="pb-1"><i class="fa fa-check green-check"></i>&nbsp;Insurance</div>
                  <div><i class="fa fa-check green-check"></i>&nbsp;Post-delivery inspection</div>
                </div>
              </div>
            </div>
          </div>
          <div class="py-2">
            <img src="assets/images/b2c/powered-by-stripe-badge.png" width="300" />
          </div>
          <div class="big-button selected proceed-button" (click)="handleEnterDetails()">
            Enter Details &nbsp; <i class="fa fa-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
<ng-template #tab2>
  <div class="ui-g">
    <div class="ui-g-12 ui-md-6">
      <form [formGroup]="pickupContactForm" [class.submitted]="contactFormSubmitted">
        <div>
          <div>
            <div class="mb-2 section-header">Collection Contact</div>

            <div class="ui-g">
              <div class="ui-g-6 pl-0 pt-0 pb-3">
                <span class="ui-float-label">
                  <input pInputText id="forename" class="b2c-input" formControlName="forename" />
                  <label for="forename">Forename*</label>
                </span>
              </div>

              <div class="ui-g-6 pr-0 pt-0 pb-3">
                <span class="ui-float-label">
                  <input pInputText id="surname" class="b2c-input" formControlName="surname" />
                  <label for="surname">Surname*</label>
                </span>
              </div>
            </div>

            <div class="mb-3">
              <span class="ui-float-label">
                <input pInputText id="contactPhone" class="b2c-input" formControlName="phone1" />
                <label for="contactPhone">Contact Phone*</label>
              </span>
              <div
                *ngIf="showPhoneError(pickupContactForm, 'phone1', contactFormSubmitted)"
                class="input-error"
              >
                Enter a valid phone number
              </div>
            </div>

            <div class="mb-3">
              <span class="ui-float-label">
                <input pInputText id="contactEmail" class="b2c-input" formControlName="email" />
                <label for="contactEmail">Contact Email*</label>
              </span>
              <div
                *ngIf="showEmailError(pickupContactForm, 'email', contactFormSubmitted)"
                class="input-error"
              >
                Enter a valid E-mail address
              </div>
            </div>
          </div>
        </div>
        <div class="contact-from">
          <div>
            <div class="ui-g mb-3">
              <div class="ui-g-12 ui-lg-6 pl-0 pr-0 pr-lg-2 pt-0 pb-1">
                <div
                  (click)="setIsPrivate(true, true)"
                  class="big-button"
                  [class.selected]="pcf['isPrivate']"
                >
                  <i class="fa fa-check" *ngIf="pcf['isPrivate']"></i>
                  Private Address
                </div>
              </div>
              <div class="ui-g-12 ui-lg-6 pr-0 pl-0 pl-lg-2 pt-0 pb-1">
                <div
                  (click)="setIsPrivate(true, false)"
                  class="big-button"
                  [class.selected]="!pcf['isPrivate']"
                >
                  <i class="fa fa-check" *ngIf="!pcf['isPrivate']"></i>
                  Business Address
                </div>
              </div>
            </div>
            <input formControlName="isPrivate" type="hidden" />
          </div>
          <div class="">
            <div class="">
              <div class="pr-3">
                <textarea
                  class="b2c-input"
                  style="height: 60px"
                  formControlName="notes"
                  placeholder="Collection Notes Eg. Preferred collection time"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="ui-g-12 ui-md-6">
      <form [formGroup]="dropoffContactForm" [class.submitted]="contactFormSubmitted">
        <div>
          <div>
            <div class="mb-2 section-header">Delivery Contact</div>

            <div class="ui-g">
              <div class="ui-g-6 pl-0 pt-0 pb-3">
                <span class="ui-float-label">
                  <input
                    pInputText
                    id="deliveryForename"
                    class="b2c-input"
                    formControlName="forename"
                  />
                  <label for="forename">Contact Name*</label>
                </span>
              </div>

              <div class="ui-g-6 pl-0 pt-0 pb-3">
                <span class="ui-float-label">
                  <input
                    pInputText
                    id="deliverySurname"
                    class="b2c-input"
                    formControlName="surname"
                  />
                  <label for="deliverySurname">Surname*</label>
                </span>
              </div>
            </div>

            <div class="mb-3">
              <span class="ui-float-label">
                <input
                  pInputText
                  id="deliveryContactPhone"
                  class="b2c-input"
                  formControlName="phone1"
                />
                <label for="deliveryContactPhone">Contact Phone*</label>
              </span>
              <div
                *ngIf="showPhoneError(dropoffContactForm, 'phone1', contactFormSubmitted)"
                class="input-error"
              >
                Enter a valid phone number address
              </div>
            </div>

            <div class="mb-3">
              <span class="ui-float-label">
                <input
                  pInputText
                  id="deliveryContactEmail"
                  class="b2c-input"
                  formControlName="email"
                />
                <label for="deliveryContactEmail">Contact Email*</label>
              </span>
              <div
                *ngIf="showEmailError(dropoffContactForm, 'email', contactFormSubmitted)"
                class="input-error"
              >
                Enter a valid E-mail address
              </div>
            </div>
          </div>
        </div>
        <div class="contact-from">
          <div class="">
            <input formControlName="isPrivate" type="hidden" />
            <div class="ui-g mb-3">
              <div class="ui-g-12 ui-lg-6 pl-0 pr-0 pr-lg-2 pb-1 pt-0">
                <div
                  (click)="setIsPrivate(false, true)"
                  class="big-button"
                  [class.selected]="dcf['isPrivate']"
                >
                  <i class="fa fa-check" *ngIf="dcf['isPrivate']"></i>
                  Private Address
                </div>
              </div>
              <div class="ui-g-12 ui-lg-6 pl-0 pr-0 pl-lg-2 pb-1 pt-0">
                <div
                  (click)="setIsPrivate(false, false)"
                  class="big-button"
                  [class.selected]="!dcf['isPrivate']"
                >
                  <i class="fa fa-check" *ngIf="!dcf['isPrivate']"></i>
                  Business Address
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="">
              <div class="pr-3">
                <textarea
                  class="b2c-input"
                  style="height: 60px"
                  formControlName="notes"
                  placeholder="Delivery Notes Eg. Preferred delivery time"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="px-2">
    <div class="d-flex flex-wrap">
      <div class="flex-grow-1">
        <div
          class="big-button back-button hollow-button inline-button"
          (click)="tabShown = tabShown - 1"
        >
          Back
        </div>
      </div>
      <div class="flex-shrink-1">
        <div class="big-button selected" (click)="saveContactDetails()">Continue</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tab3>
  <div>
    <div class="ui-g">
      <div class="ui-g-12">
        <div class="section-header">Billing Details</div>
      </div>
      <form [formGroup]="billingDetailsForm" [class.submitted]="billingFormSubmitted">
        <div class="ui-g-12">
          <span class="ui-float-label">
            <input
              pInputText
              id="cardholderCompany"
              class="b2c-input"
              formControlName="businessName"
            />
            <label for="cardholderCompany">Company Name (if applicable)</label>
          </span>
        </div>
        <div class="ui-g-12 ui-md-6">
          <span class="ui-float-label">
            <input pInputText id="cardholderName" class="b2c-input" formControlName="forename" />
            <label for="cardholderName">Cardholder Name*</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-6">
          <span class="ui-float-label">
            <input pInputText id="cardholderPhone" class="b2c-input" formControlName="phone1" />
            <label for="cardholderPhone">Billing Phone*</label>
          </span>

          <div
            *ngIf="showPhoneError(billingDetailsForm, 'phone1', billingFormSubmitted)"
            class="input-error"
          >
            Enter a valid phone number
          </div>
        </div>

        <div class="ui-g-6">
          <span class="ui-float-label">
            <input
              pInputText
              id="billingAddress1"
              class="b2c-input"
              formControlName="addressLine1"
            />
            <label for="billingAddress1">Billing Address Line 1*</label>
          </span>
        </div>

        <div class="ui-g-6">
          <span class="ui-float-label">
            <input
              pInputText
              id="billingAddress2"
              class="b2c-input"
              formControlName="addressLine2"
            />
            <label for="billingAddress2">Billing Address Line 2</label>
          </span>
        </div>

        <div class="ui-g-6">
          <span class="ui-float-label">
            <input pInputText id="billingTown" class="b2c-input" formControlName="town" />
            <label for="billingTown">Billing Town</label>
          </span>
        </div>

        <div class="ui-g-6">
          <span class="ui-float-label">
            <input pInputText id="billingCounty" class="b2c-input" formControlName="city" />
            <label for="billingCounty">Billing County</label>
          </span>
        </div>

        <div class="ui-g-6">
          <span class="ui-float-label">
            <input pInputText id="billingPostcode" class="b2c-input" formControlName="postcode" />
            <label for="billingCounty">Billing Postcode</label>
          </span>
        </div>

        <div class="ui-g-6">
          <span class="ui-float-label">
            <input pInputText id="cardholderEmail" class="b2c-input" formControlName="email" />
            <label for="cardholderName">Billing E-mail*</label>
          </span>
          <div
            *ngIf="showEmailError(billingDetailsForm, 'email', billingFormSubmitted)"
            class="input-error"
          >
            Enter a valid E-mail address
          </div>
        </div>

        <div class="ui-g-6" *ngIf="!useBillingEmailForInvoice">
          <span class="ui-float-label">
            <input pInputText id="invoiceEmail" class="b2c-input" formControlName="invoiceEmail" />
            <label for="invoiceEmail">Invoice Email*</label>
          </span>
        </div>

        <div class="ui-g-12 pl-3">
          <p-checkbox
            binary="true"
            [(ngModel)]="useBillingEmailForInvoice"
            [ngModelOptions]="{ standalone: true }"
            class="b2c-input"
          ></p-checkbox>
          Use Billing Email for Invoices
        </div>

        <div class="ui-g-12 pl-3">
          <p-checkbox
            [binary]="'true'"
            formControlName="termsAgreed"
            class="b2c-input"
          ></p-checkbox>
          I have read and agree to the
          <a
            class="cursor-pointer"
            href="https://s3.eu-west-2.amazonaws.com/bucket.engineius.portal-static-content/b2c/terms.html"
            >Engineius Terms + Conditions</a
          >
        </div>
      </form>
    </div>
    <div class="pt-2">
      <div class="px-2">
        <div class="d-flex flex-wrap">
          <div class="flex-grow-1">
            <div class="big-button back-button hollow-button inline-button" (click)="goToTab(2)">
              Back
            </div>
          </div>
          <div class="flex-shrink-1">
            <div class="big-button selected" (click)="saveBillingDetails()">
              Proceed to Payment <i class="fa fa-spin fa-spinner" *ngIf="creatingPaymentIntent"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tab4>
  <b2c-payment-confirmation [quote]="quote"></b2c-payment-confirmation>
  <div class="pt-2" *ngIf="clientSecret != ''">
    <div class="px-2">
      <div class="ui-g card-box px-4 py-2">
        <div class="ui-md-6 align-items-center">
          <ngx-stripe-payment
            (change)="paymentChange($event)"
            [options]="stripeOptions"
            [clientSecret]="clientSecret"
          >
          </ngx-stripe-payment>

          <div class="big-button selected" (click)="pay()" *ngIf="canSubmitPayment()">
            Submit Secure Payment <i class="fa fa-spin fa-spinner" *ngIf="paying"></i>
          </div>
        </div>
        <div class="ui-md-6 text-center pt-3 ui-hide">
          <img src="/assets/images/b2c/powered-by-stripe-badge.png" height="60" />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<b2c-address-confirmation
  [address]="editAddress"
  [visible]="showAddress"
  (visibleChange)="showAddress = $event"
  (addressChange)="addressChange($event)"
  [isPickup]="addressIsPickup"
></b2c-address-confirmation>

<p-dialog
  [modal]="true"
  [contentStyle]="{ 'padding-top': '0px' }"
  [(visible)]="showDateDialog"
  [closeOnEscape]="true"
  header="Collection Date"
>
  <div style="width: 550px">
    <table class="w-100 calendar">
      <thead>
        <tr>
          <th colspan="7" style="text-align: center">
            <i class="fa fa-arrow-left arrows" (click)="changeMonth(-1)"></i>
            &nbsp;
            <span class="calendar-my">{{ calendarMonthName }} {{ calendarYear }}</span>
            &nbsp;
            <i class="fa fa-arrow-right arrows" (click)="changeMonth(1)"></i>
          </th>
        </tr>
        <tr class="days">
          <th>Sun</th>
          <th>Mon</th>
          <th>Tue</th>
          <th>Wed</th>
          <th>Thu</th>
          <th>Fri</th>
          <th>Sat</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let week of weeksInMonth">
          <td
            *ngFor="let day of week"
            style="position: relative"
            [class.today]="day?.date == today"
            class="daycell"
            (click)="setCustomDateSelected(day)"
            [class.dateChosen]="isDateChosen(day)"
            [class.disabled]="day?.disabled"
          >
            <div class="dayOfMonth">{{ day?.dayOfMonth }}</div>
            <div class="price" *ngIf="day?.showPrice">&pound;{{ day?.price }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div style="font-weight: bold" class="mt-3 mb-2">Collection timeslot</div>

    <p-dropdown [options]="timeSlotOptions" [(ngModel)]="timeSlot" appendTo="body"></p-dropdown>
  </div>

  <div class="mb-2 mt-3">
    <div class="big-button selected" *ngIf="canAcceptCustomDate()" (click)="confirmCustomDate()">
      Continue
    </div>
  </div>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="showCallUsDialog"
  [closable]="true"
  [closeOnEscape]="true"
  (onHide)="reload()"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff' }"
>
  <p-header>Call Us</p-header>
  <div>We are sorry but we are unable to provide an online quote for this vehicle.</div>
  <div>
    Please call us on
    <a href="tel:+441214812111" style="font-weight: bold">0121 481 2111</a> discuss your
    requirements.
  </div>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="showMoreInfoDialog"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff' }"
>
  <p-header>Please call</p-header>
  <div style="font-size: 17px"><b>Your order has been processed.</b></div>
  <div>However we require some additional information.</div>
  <div>
    Please call us on <a href="tel:+441214812111" style="font-weight: bold">0121 481 2111</a> to
    finalise your requirements.
  </div>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="discountDialogVisible"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff', width: '400px' }"
>
  <p-header>Discount Code</p-header>
  <div>
    <div class="style2023 px-3 pt-3">
      <div class="input-group">
        <div class="input-group-item">
          <input [(ngModel)]="discountCode" pInputText placeholder="Enter Discount Code" />
        </div>
        <div class="input-group-append">
          <div class="input-group-text cursor-pointer" (click)="applyDiscountCode()">Apply</div>
        </div>
      </div>
      <div
        style="
          min-height: 30px;
          padding-left: 15px;
          padding-top: 5px;
          font-size: 13px;
          font-weight: 500;
        "
      >
        <div *ngIf="!discountDisplayTextIsValid" class="discount-error">
          {{ discountDisplayText }}
        </div>
        <div *ngIf="discountDisplayTextIsValid" class="discount-applied">
          Success!&nbsp;
          <span style="font-weight: 700">"{{ discountDisplayText }}"</span> &nbsp;code applied
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button pButton label="Close" (click)="discountDialogVisible = false"></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="offshoreQuoteDialogVisible"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff', width: '400px' }"
>
  <p-header>Booking Unavailable</p-header>
  <div>
    <div class="style2023 px-3 pt-3">
      Bookings outside the UK Mainland aren’t available via our online checkout. Please use our
      portal to enquire
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button pButton label="Close" (click)="offshoreQuoteDialogVisible = false"></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="additionalVehicleInformationRequiredDialogVisible"
  [closable]="true"
  [closeOnEscape]="true"
  (onHide)="onKerbWeightDialogClosed()"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff', width: '500px' }"
  *ngIf="quote?.quoteVehicle"
>
  <p-header>Additional Information Required</p-header>
  <div class="additional-info-entry style2023">
    <div class="px-3 pt-3">
      We were unable to find the Kerb Weight of the vehicle you have selected. Please provide this
      below:
    </div>

    <div class="ui-g mt-2">
      <div class="ui-g-12">
        <span class="ui-float-label">
          <input
            pInputText
            id="kerbWeight"
            name="kerbWeight"
            class="b2c-input"
            [(ngModel)]="manualKerbWeightValue"
            (keydown)="limitKerbWeight($event)"
            (keyup)="limitKerbWeight($event)"
            pattern="^(?:[1-9][0-9]{0,4}(?:\.\d{1,2})?|44000)$"
            [ngClass]="{
              'b2c-input-invalid':
                manualKerbWeightValue != null &&
                (manualKerbWeightValue < minKerbWeight || manualKerbWeightValue > maxKerbWeight)
            }"
          />
          <label for="kerbWeight">Kerb Weight (KG)</label>
        </span>
        <small
          *ngIf="
            manualKerbWeightValue != null &&
            (manualKerbWeightValue < minKerbWeight || manualKerbWeightValue > maxKerbWeight)
          "
          class="input-error"
        >
          Kerb weight must be between {{ minKerbWeight }}kg and {{ maxKerbWeight | number }}kg.
        </small>
      </div>
    </div>

    <div class="additional-info-disclaimer">
      <span
        ><strong>Disclaimer:</strong> By continuing you agree that the kerb weight entered is
        correct. Engineius reserves the right to abort or cancel any booking where the vehicle
        weight has been incorrectly entered.</span
      >
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button
        pButton
        label="Continue"
        (click)="continueWithManualKerbWeightEntry()"
        [disabled]="!canContinueWithManualKerbWeight()"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="isTransportedMovementDialogVisible"
  [closable]="false"
  [closeOnEscape]="false"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff', width: '600px' }"
>
  <p-header>Disclaimer</p-header>
  <div>
    <div class="style2023 px-3 pt-3">
      Your Transported Delivery booking will be accepted on the basis that the vehicle can be
      <b>driven</b> onto a transporter.
      <p>
        If the vehicle cannot be driven for loading purposes at the point of collection, the booking
        will be treated as a Full Abort with no refund.
      </p>
      <p>
        We do not accept any responsibility or liability for the vehicle’s internal condition or
        structural integrity — including windows, doors, locking mechanisms, or any other internal
        arrangements — if these are found to be faulty at the time of collection.
      </p>
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button
        class="ui-button-primary"
        pButton
        icon="fa ui-icon-check"
        label="Accept"
        (click)="handleTransportedMovementDialog(true)"
      ></button>
      <button
        class="ui-button-secondary"
        pButton
        icon="fa ui-icon-close"
        label="Decline"
        (click)="handleTransportedMovementDialog(false)"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="isInvalidMOTDialogVisible"
  [closable]="false"
  [closeOnEscape]="false"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff', width: '600px' }"
>
  <p-header>MOT Status</p-header>
  <div>
    <div class="style2023 px-3 pt-3">
      <ng-container *ngIf="isInvalidMOT">
        We could not find the MOT status for the vehicle
        {{ this.quote?.quoteVehicle?.registrationNumber }}.
        <p>
          Please confirm that the vehicle will have a valid MOT for the duration of the booking
          window.
        </p>
      </ng-container>
      <ng-container *ngIf="isMOTExpiring">
        The MOT for vehicle {{ this.quote?.quoteVehicle?.registrationNumber }} expires on
        {{ this.quote?.quoteVehicle?.motExpiryDate | date : 'dd/MM/yy' }}.
        <p>
          Please confirm that the vehicle will have a valid MOT by
          {{ this.quote?.pickupDateTimeEarliest | date : 'dd/MM/yy' }}.
        </p>
      </ng-container>
      <div style="text-align: center; flex-grow: 1">
        <p-checkbox
          class="style2023"
          id="confirmValidMOT"
          name="confirmValidMOT"
          [(ngModel)]="quote.quoteVehicle.hasCustomerAcceptedInvalidMot"
          binary="true"
        ></p-checkbox>
        <label class="checkbox-label">I confirm the vehicle will have a valid MOT</label>
      </div>
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button
        class="ui-button-primary"
        pButton
        icon="fa ui-icon-check"
        label="Confirm"
        [disabled]="!quote?.quoteVehicle?.hasCustomerAcceptedInvalidMot"
        (click)="handleInvalidMOTDialog(true)"
      ></button>
      <button
        class="ui-button-secondary"
        pButton
        icon="fa ui-icon-close"
        label="Book as Transported"
        (click)="handleInvalidMOTDialog(false)"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="isUnableToBookDrivenMotorcycleDialogVisible"
  [closable]="false"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff', width: '600px' }"
>
  <p-header>Unable to book driven movement</p-header>
  <div class="style2023 px-3 pt-3">
    A driven movement cannot be booked for a vehicle of this type.
    <p>
      To proceed, please book as a transported movement or call us on
      <a href="tel:+441214812111" style="font-weight: bold">0121 481 2111</a> to discuss your
      requirements.
    </p>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button
        class="ui-button-primary"
        pButton
        icon="fa ui-icon-check"
        label="Book as Transported"
        (click)="
          isUnableToBookDrivenMotorcycleDialogVisible = false;
          setTaskType(TaskType.UncoveredTransportedMovement)
        "
      ></button>
      <button
        class="ui-button-secondary"
        pButton
        icon="fa ui-icon-close"
        label="Decline"
        (click)="isUnableToBookDrivenMotorcycleDialogVisible = false; showCallUsDialog = true"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<!---

<p-dialog
    [modal]="true"
    [styleClass]="'dialog-container'"
    [(visible)]="showDateDialog"
    [closable]="true"
    [closeOnEscape]="true"
    [style]="{ 'max-width': '1024px', 'background-color': '#fff' }"
>
  <p-header>Collection Date/Time</p-header>

  <div style="text-align: center" class="mb-3">
    <p-calendar
        class="max-w-full"
        [minDate]="minBookingWindow"
        [disabledDays]="[0, 6]"
        (ngModelChange)="setCustomDateSelected($event)"
        [(ngModel)]="customDate"
        [inline]="true"
    >
    </p-calendar>



    <div class="mb-3 mt-3">
      <span style="font-size: 18px"
      >Price:
        <span style="font-weight: 600; font-size: 23px"
        >&pound; {{ datePrice(deliveryDate) | number : '1.2-2' }}</span
        >
        +VAT</span
      >
    </div>
    <div class="mb-2">
      <div class="big-button selected" *ngIf="canAcceptCustomDate()" (click)="confirmCustomDate()">
        Continue
      </div>
    </div>
  </div>
</p-dialog>

--->
